import { Box, Button, Typography } from '@mui/material';
import { ReactElement, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { NavLink, useNavigate } from 'react-router-dom';

export const NotFoundPage = (): ReactElement => {
  const navigate = useNavigate();

  const hasPreviousHistory = window.history.length > 2;

  const handleGoBack = useCallback(() => {
    void navigate(-1);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Page not found</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          height: 'auto',
        }}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            borderRadius: '100%',
            padding: 3,
            width: 180,
            height: 180,
          }}
        />

        <Box
          sx={{
            textAlign: 'center',
            marginTop: 2,
            color: 'text.primary',
          }}
        >
          <Typography variant="h5" component="h1" gutterBottom>
            Page not found
          </Typography>

          {hasPreviousHistory && (
            <Box
              sx={{
                marginX: 2,
                display: 'inline',
              }}
            >
              <Button variant="contained" onClick={handleGoBack}>
                GO BACK
              </Button>
            </Box>
          )}

          <Button variant={hasPreviousHistory ? 'text' : 'contained'} component={NavLink} to=".">
            GO TO DASHBOARD
          </Button>
        </Box>
      </Box>
    </>
  );
};
